import React, { useState } from "react";
import CompanyBasedBillableListing from "@/modules/reports/billables/status/company-listing";
import { StatsSection } from "@/modules/reports/billables/status/components/stats-section";
import PendingInvoiceFilters from "@/modules/reports/billables/status/pending_invoice/filters";
import { statusWiseBillingDateFilters } from "@/modules/reports/billables/status/constant";
import CommonTable from "components/list/table";
import {
  getChildData,
  getChildColumns,
  getBillableFiltersFromCompanyFilters,
} from "@/modules/reports/billables/status/child-table-config";

const PendingBillables = () => {
  const [filters, setFilters] = useState({
    contacts: {
      projects: {
        jobs: {
          billables: {
            // ...statusWiseBillingDateFilters,
            status: {
              _eq: "pending_invoice",
            },
          },
        },
      },
    },
  });

  return (
    <div>
      <CompanyBasedBillableListing
        title="Pending Invoice Billables"
        status="pending_invoice"
        onFiltersChange={setFilters}
        filters={PendingInvoiceFilters}
        sortOrder="asc"
        sortBy="contacts.projects.jobs.billables.billing_date"
        enableAccordion={true}
        renderExpandedRow={(row) => (
          <div className="border rounded-md overflow-hidden bg-background">
            <CommonTable
              data={getChildData(row, "pending_invoice")}
              columns={getChildColumns("pending_invoice")}
              showHeader={true}
            />
          </div>
        )}
        renderContent={() => (
          <StatsSection
            status="pending_invoice"
            filters={getBillableFiltersFromCompanyFilters(filters)}
          />
        )}
        statusWiseFilters={{
          contacts: {
            projects: {
              jobs: {
                billables: {
                  // ...statusWiseBillingDateFilters,
                  status: {
                    _eq: "pending_invoice",
                  },
                },
              },
            },
          },
        }}
        // statusWiseDateFilters={statusWiseBillingDateFilters}
      />
    </div>
  );
};

export default PendingBillables;
